import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { PaymentRequestComponent } from './payment-request/payment-request.component';
import { PaymentResultComponent } from './payment-result/payment-result.component';
import { EnvironmentConfigService } from 'src/shared/service/environment-config.service';

const appInitializerFn = (environmentConfigService: EnvironmentConfigService) => {
  return () => environmentConfigService.setConfig();
};

@NgModule({
  declarations: [
    AppComponent,
    PaymentRequestComponent,
    PaymentResultComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot([
      { path: 'payment-request/:tc', component: PaymentRequestComponent },
      { path: 'payment-result/:tc', component: PaymentResultComponent },
    ])
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [EnvironmentConfigService]
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
